;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('emitLastRepeaterItem', emitLastRepeaterItem)

  function emitLastRepeaterItem () {
    return function (scope) {
      if (scope.$last) {
        scope.$emit('LastRepeaterItem', scope)
      }
    }
  }
})()
